import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import AuthUserModelInterface from "../../shared/interfaces/auth-user-model.interface";

@Injectable({
  providedIn: "root",
})
export abstract class AuthService {
  abstract getToken(): string | undefined;
  abstract getUser(): AuthUserModelInterface | undefined;
  abstract logout(): Observable<void>;

  user$ = new BehaviorSubject<AuthUserModelInterface | undefined>(undefined);
  token$ = new BehaviorSubject<string | undefined>(undefined);
}
